import { Component, OnInit } from '@angular/core';
import { UserService } from '../services/user.service';
import { Salon } from '../models/salon/salon.model';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { MailingAddressComponent } from '../components/mailing-address/mailing-address.component';
@Component({
  selector: 'app-marketing',
  templateUrl: './marketing.page.html',
  styleUrls: ['./marketing.page.scss'],
})
export class MarketingPage implements OnInit {

  public tab: string;

  public salon: Salon;
 
  constructor (private userService: UserService,
               private router: Router,
               private modalCtrl: ModalController

          ) { 
    this.tab = 'marketing-composer';
    this.salon = userService.getSalon().clone();

  }

  public async ngOnInit () {

    if (
      this.salon.address1 == "" || this.salon.address1 == undefined ||
      this.salon.city == "" || this.salon.city == undefined ||
      this.salon.province == "" || this.salon.province == undefined ||
      this.salon.postal == "" || this.salon.postal == undefined ||
      this.salon.postal == "" || this.salon.postal == undefined ||
      this.salon.country == undefined
    ) {
      const modal = await this.modalCtrl.create({
        component: MailingAddressComponent,
        backdropDismiss: false
      })
  
      modal.present()
    }
  }

}
